import { combineReducers } from "redux";
import {
  editorsReducer,
  partnersReducer,
  userReducer,
  reportTimeReducer,
  orderDataReducer,
  purchaseDataReducer,
  searchReducer,
  notificationReducer,
  cartReducer,
} from "./useReducers";

const reducers = combineReducers({
  user: userReducer,
  partners: partnersReducer,
  editors: editorsReducer,
  reportTime: reportTimeReducer,
  order: orderDataReducer,
  supplier: purchaseDataReducer,
  search: searchReducer,
  notifications: notificationReducer,
  cart: cartReducer,
});

export default reducers;
